import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

const Header = () => {

    const headerContent = (
        <div>
            <AppBar position="static" sx={{ backgroundColor: '#1976d2' }}>
                <Toolbar>
                    <Typography
                        variant="h6"
                        sx={{
                            width: '100%',
                            textAlign: 'center',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 900,
                        }}
                    >
                        SCM API Manager
                    </Typography>
                </Toolbar>
            </AppBar>
        </div>
    );


    return (
        headerContent
    );
};

export default Header;